import { ThemeEnum } from '@enum/style/theme.enum';

import { darkThemeConfig } from './components/dark-theme.config';
import { lightThemeConfig } from './components/light-theme.config';

export const loadTheme = (theme: ThemeEnum) => {
  switch (theme) {
    case ThemeEnum.Dark:
      return darkThemeConfig;
    default:
      return lightThemeConfig;
  }
};
